// extracted by mini-css-extract-plugin
module.exports = {"Tab":"Tab_Tab__35fkE","Pointer":"Tab_Pointer__2u3Fw"};